import EZFileLogo from '@/assets/img/ez-file-logo';
import { stytch } from '@/auth/stytch';
import { ArrowUpward } from '@/components/icons/ArrowUpward';
import { FaAnswers } from '@/state/state.types';
import { DASHBOARD_ROUTES, getDashboardURL } from '@/utils/dashboardUrl';
import { Anchor, Button, Flex, Stack, Text, useMantineTheme } from '@mantine/core';
import { Dispatch, SetStateAction } from 'react';

const redirectToEzFileDashboard = () => {
  const tokens = stytch.session.getTokens();
  return `${getDashboardURL()}/${DASHBOARD_ROUTES.sessionAuthenticate}?sessionToken=${
    tokens?.session_token ?? ''
  }&ezFile=true`;
};

interface Props {
  isLoading: boolean;
  showBottomLink: boolean;
  setAnswer: Dispatch<SetStateAction<'' | FaAnswers>>;
}

export const FinancialAidActions = ({ isLoading, showBottomLink, setAnswer }: Props) => {
  const theme = useMantineTheme();

  return (
    <Stack
      spacing={16}
      maw={460}
      mt={8}
    >
      <Anchor
        href={redirectToEzFileDashboard()}
        target="_blank"
        w="100%"
        style={{ textDecoration: 'none' }}
      >
        <Button
          type="button"
          onClick={() => setAnswer(FaAnswers.yes)}
          loading={isLoading}
          radius="3.125rem"
          h={56}
          w="100%"
          styles={{
            root: {
              backgroundColor: theme.colors.tertiary[3],
              '&:hover': { backgroundColor: theme.colors.tertiary[3] },
            },
            label: { fontWeight: 700, color: theme.colors.minor[1] },
          }}
        >
          <Flex
            align="center"
            gap={10}
          >
            <Text
              fw={700}
              c="minor.1"
            >
              Continue with
            </Text>
            <EZFileLogo
              width={70}
              flat
            />
          </Flex>
        </Button>
      </Anchor>

      <Button
        type="button"
        onClick={() => setAnswer(FaAnswers.rejected)}
        loading={isLoading}
        radius="3.125rem"
        h={56}
        w="100%"
        styles={{
          root: {
            backgroundColor: theme.colors.primary[2],
            '&:hover': { backgroundColor: theme.colors.primary[2] },
          },
          label: { fontWeight: 700, color: theme.colors.primary[0] },
        }}
      >
        I Was Already Rejected for Financial Assistance
      </Button>

      {showBottomLink && (
        <Button
          type="button"
          onClick={() => setAnswer(FaAnswers.no)}
          loading={isLoading}
          variant="subtle"
          mt={4}
          styles={{
            root: {
              backgroundColor: 'transparent',
              '&:hover': { backgroundColor: 'transparent' },
              padding: 0,
            },
          }}
        >
          <Flex
            align="center"
            gap={6}
          >
            <Text
              fw={700}
              c="white"
            >
              I&apos;d Rather Resolve Work on My Behalf
            </Text>
            <ArrowUpward color={theme.colors.minor[1]} />
          </Flex>
        </Button>
      )}
    </Stack>
  );
};
